<div
	*ngIf="infoText"
	class="infoTextWrapper {{baseClass}}"
	[ngClass]="{
		'disableHoverStyle': disableHoverStyle,
		'disableFocusStyle': disableFocusStyle
	}"
>
	<i *ngIf="!hideInfoIcon" class="me-2 align-middle infoText--icon {{iconClass}}"></i>
	<span *ngIf="!hideInfoText" class="infoText--text {{textClass}}" [innerHTML]="infoText"></span>
</div>
